@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.wrapper {
    border-bottom: 1px solid var(--color-black);
    padding: 3.125rem 0;
}

.heading {
    font-size: 1.875rem;
}

.list {
    display: grid;
}

.oneColumn {
    grid-template-columns: 1fr;
}

.twoColumn {
    column-gap: 2%;
    grid-template-columns: 1fr 1fr;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }
}

.question {
    background-color: var(--color-crimson);
    border: none;
    border-bottom: 1px solid var(--color-white);
    color: var(--color-white);
    cursor: pointer;
    display: block;
    font-size: 1.125rem;
    font-weight: 500;
    padding: 18px 50px 16px 18px;
    position: relative;
    text-align: left;
    text-transform: uppercase;
    width: 100%;

    &::after {
        background-color: var(--color-white);
        content: "";
        display: block;
        height: 25px;
        margin-right: 0.25rem;
        mask-image: url("data:image/svg+xml,%3Csvg width='18' height='11' viewBox='0 0 18 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.17523 3.19386L1.18446 3.20412L8.04917 10.0336C8.56082 10.5449 9.4045 10.5446 9.91605 10.0332L16.7804 3.20412L16.7896 3.19386C17.2675 2.66284 17.2928 1.83181 16.7715 1.31051L15.9629 0.50192C15.4416 -0.0193729 14.6106 0.00590758 14.0796 0.483827L14.0698 0.492623L8.99886 5.56357L3.89444 0.492081L3.88527 0.483827C3.35425 0.00590758 2.52321 -0.0193729 2.00192 0.50192L1.19333 1.31051C0.672034 1.83181 0.697314 2.66284 1.17523 3.19386Z' fill='black'/%3E%3C/svg%3E");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 20px 20px;
        min-width: 25px;
        position: absolute;
        right: 16px;
        top: 18px;
    }

    &[aria-expanded="true"] {
        &::after {
            mask-image: url("data:image/svg+xml,%3Csvg width='18' height='11' viewBox='0 0 18 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.7896 7.34148L16.7804 7.33123L9.91567 0.501712C9.40417 -0.0093676 8.56039 -0.0088283 8.04879 0.502095L1.18446 7.33123L1.17523 7.34148C0.697314 7.8725 0.672034 8.70354 1.19333 9.22483L2.00192 10.0334C2.52321 10.5547 3.35425 10.5294 3.88527 10.0515L3.89444 10.0433L8.99886 4.97177L14.0698 10.0427L14.0796 10.0515C14.6106 10.5294 15.4416 10.5547 15.9629 10.0334L16.7715 9.22483C17.2928 8.70354 17.2675 7.8725 16.7896 7.34148Z' fill='black'/%3E%3C/svg%3E%0A");
        }
    }
}

.answer {
    background-color: var(--color-white);
    padding: 1.625rem 1.125rem;
}
